/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accessRolePresetRetrieve } from '../fn/access-role-presets/access-role-preset-retrieve';
import { AccessRolePresetRetrieve$Params } from '../fn/access-role-presets/access-role-preset-retrieve';
import { accessRolePresetsCreate } from '../fn/access-role-presets/access-role-presets-create';
import { accessRolePresetsCreate$FormData } from '../fn/access-role-presets/access-role-presets-create-form-data';
import { AccessRolePresetsCreate$FormData$Params } from '../fn/access-role-presets/access-role-presets-create-form-data';
import { AccessRolePresetsCreate$Params } from '../fn/access-role-presets/access-role-presets-create';
import { accessRolePresetsCreate$XWwwFormUrlencoded } from '../fn/access-role-presets/access-role-presets-create-x-www-form-urlencoded';
import { AccessRolePresetsCreate$XWwwFormUrlencoded$Params } from '../fn/access-role-presets/access-role-presets-create-x-www-form-urlencoded';
import { accessRolePresetsDestroy } from '../fn/access-role-presets/access-role-presets-destroy';
import { AccessRolePresetsDestroy$Params } from '../fn/access-role-presets/access-role-presets-destroy';
import { accessRolePresetsList } from '../fn/access-role-presets/access-role-presets-list';
import { AccessRolePresetsList$Params } from '../fn/access-role-presets/access-role-presets-list';
import { accessRolePresetsUpdate } from '../fn/access-role-presets/access-role-presets-update';
import { AccessRolePresetsUpdate$Params } from '../fn/access-role-presets/access-role-presets-update';
import { accessRolesRetrieve } from '../fn/access-role-presets/access-roles-retrieve';
import { AccessRolesRetrieve$Params } from '../fn/access-role-presets/access-roles-retrieve';
import { BackendRolePresetDto } from '../models/backend-role-preset-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAccessRolePresetsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accessRolePresetsList()` */
  static readonly AccessRolePresetsListPath = '/api/access/role-presets/';

  /**
   * Список пресетов (системные + собственные).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetsList$Response(
    params?: AccessRolePresetsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRolePresetDto>> {
    return accessRolePresetsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Список пресетов (системные + собственные).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetsList(
    params?: AccessRolePresetsList$Params,
    context?: HttpContext,
  ): Observable<BackendRolePresetDto> {
    return this.accessRolePresetsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRolePresetDto>): BackendRolePresetDto => r.body),
    );
  }

  /** Path part for operation `accessRolePresetsCreate()` */
  static readonly AccessRolePresetsCreatePath = '/api/access/role-presets/';

  /**
   * Создать пресет (с дефолтной матрицей ГОСТЯ).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessRolePresetsCreate$Response(
    params: AccessRolePresetsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRolePresetDto>> {
    return accessRolePresetsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать пресет (с дефолтной матрицей ГОСТЯ).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessRolePresetsCreate(
    params: AccessRolePresetsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendRolePresetDto> {
    return this.accessRolePresetsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRolePresetDto>): BackendRolePresetDto => r.body),
    );
  }

  /**
   * Создать пресет (с дефолтной матрицей ГОСТЯ).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessRolePresetsCreate$XWwwFormUrlencoded$Response(
    params: AccessRolePresetsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRolePresetDto>> {
    return accessRolePresetsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать пресет (с дефолтной матрицей ГОСТЯ).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessRolePresetsCreate$XWwwFormUrlencoded(
    params: AccessRolePresetsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendRolePresetDto> {
    return this.accessRolePresetsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRolePresetDto>): BackendRolePresetDto => r.body),
    );
  }

  /**
   * Создать пресет (с дефолтной матрицей ГОСТЯ).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessRolePresetsCreate$FormData$Response(
    params: AccessRolePresetsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRolePresetDto>> {
    return accessRolePresetsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать пресет (с дефолтной матрицей ГОСТЯ).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessRolePresetsCreate$FormData(
    params: AccessRolePresetsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendRolePresetDto> {
    return this.accessRolePresetsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRolePresetDto>): BackendRolePresetDto => r.body),
    );
  }

  /** Path part for operation `accessRolePresetRetrieve()` */
  static readonly AccessRolePresetRetrievePath = '/api/access/role-presets/{pid}/';

  /**
   * Детали пресета.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetRetrieve$Response(
    params: AccessRolePresetRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRolePresetDto>> {
    return accessRolePresetRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Детали пресета.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetRetrieve(
    params: AccessRolePresetRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendRolePresetDto> {
    return this.accessRolePresetRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRolePresetDto>): BackendRolePresetDto => r.body),
    );
  }

  /** Path part for operation `accessRolePresetsUpdate()` */
  static readonly AccessRolePresetsUpdatePath = '/api/access/role-presets/{pid}/';

  /**
   * Обновить пресет (включая матрицу).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetsUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetsUpdate$Response(
    params: AccessRolePresetsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRolePresetDto>> {
    return accessRolePresetsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить пресет (включая матрицу).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetsUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetsUpdate(
    params: AccessRolePresetsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendRolePresetDto> {
    return this.accessRolePresetsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRolePresetDto>): BackendRolePresetDto => r.body),
    );
  }

  /** Path part for operation `accessRolePresetsDestroy()` */
  static readonly AccessRolePresetsDestroyPath = '/api/access/role-presets/{pid}/';

  /**
   * Удалить пресет (сбрасывает members в null).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolePresetsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetsDestroy$Response(
    params: AccessRolePresetsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessRolePresetsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить пресет (сбрасывает members в null).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolePresetsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolePresetsDestroy(params: AccessRolePresetsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.accessRolePresetsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `accessRolesRetrieve()` */
  static readonly AccessRolesRetrievePath = '/api/access/roles/';

  /**
   * GET /api/access/roles/ — сводный справочник всех ролей и пресетов
   * для UI-страницы «Сравнить все роли» (TZ_role_model_full раздел 5.4 / F8).
   *
   * Возвращает:
   *   - 3 системные роли (owner/admin/guest) с дефолтными матрицами,
   *   - системные пресеты (read-only, owner=None, is_system=True),
   *   - кастом-пресеты текущего пользователя,
   *   - registry SECTION_ACTIONS — для UI чтобы знать применимость (5 действий
   *     × 18 разделов, ячейки вне registry рендерятся как 'not_applicable').
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessRolesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolesRetrieve$Response(
    params?: AccessRolesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessRolesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * GET /api/access/roles/ — сводный справочник всех ролей и пресетов
   * для UI-страницы «Сравнить все роли» (TZ_role_model_full раздел 5.4 / F8).
   *
   * Возвращает:
   *   - 3 системные роли (owner/admin/guest) с дефолтными матрицами,
   *   - системные пресеты (read-only, owner=None, is_system=True),
   *   - кастом-пресеты текущего пользователя,
   *   - registry SECTION_ACTIONS — для UI чтобы знать применимость (5 действий
   *     × 18 разделов, ячейки вне registry рендерятся как 'not_applicable').
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessRolesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessRolesRetrieve(params?: AccessRolesRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.accessRolesRetrieve$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }
}
